import { IPagination } from 'app/types/common';

export interface ITeamMember {
  fullName: string;
  email: string;
  mobile: string;
  createdAt: Date;
  updatedAt: Date;
  status: null;
  teamName: string;
  team: {
    id: string;
  };
  consumer: {
    id: string;
  };
  financialStatus: string;
  pendingTeamPaymentCollectionsTotalCount: number;
  paidTeamPaymentCollectionsTotalCount: number;
  overdueTeamPaymentCollectionsTotalCount: number;
  pendingTeamPaymentCollectionsTotalAmount: number;
  paidTeamPaymentCollectionsTotalAmount: number;
  overdueTeamPaymentCollectionsTotalAmount: number;
}
export interface ITeamMembersState {
  readonly teamMembersById?: any;
  readonly teamMemberIds?: string[];
  readonly hasSaved?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly showAddTeamMember?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationTeamMemberIds?: string[];
  readonly currentTeamMemberId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface ITeamMembersSelector extends ITeamMembersState {
  readonly currentTeamMember?: any;
  readonly currentFormTeamMember?: any;
  readonly getTeamMembersFilteredByTagInSelectFormat?: any;
  readonly teamMembersByIdInSelectFormat?: any;
}

export enum TeamMembersActionTypes {
  GET_ALL_TEAM_MEMBERS_REQUESTED = 'redux-app/team-members/GET_ALL_TEAM_MEMBERS_REQUESTED',
  GET_ALL_TEAM_MEMBERS_PENDING = 'redux-app/team-members/GET_ALL_TEAM_MEMBERS_PENDING',
  GET_ALL_TEAM_MEMBERS_SUCCESS = 'redux-app/team-members/GET_ALL_TEAM_MEMBERS_SUCCESS',
  GET_ALL_TEAM_MEMBERS_FAIL = 'redux-app/team-members/GET_ALL_TEAM_MEMBERS_FAIL',
  GET_TEAM_MEMBER_REQUESTED = 'redux-app/team-members/GET_TEAM_MEMBER_REQUESTED',
  GET_TEAM_MEMBER_PENDING = 'redux-app/team-members/GET_TEAM_MEMBER_PENDING',
  GET_TEAM_MEMBER_SUCCESS = 'redux-app/team-members/GET_TEAM_MEMBER_SUCCESS',
  GET_TEAM_MEMBER_FAIL = 'redux-app/team-members/GET_TEAM_MEMBER_FAIL',
  UPDATE_TEAM_MEMBER_REQUESTED = 'redux-app/team-members/UPDATE_TEAM_MEMBER_REQUESTED',
  UPDATE_TEAM_MEMBER_PENDING = 'redux-app/team-members/UPDATE_TEAM_MEMBER_PENDING',
  UPDATE_TEAM_MEMBER_SUCCESS = 'redux-app/team-members/UPDATE_TEAM_MEMBER_SUCCESS',
  UPDATE_TEAM_MEMBER_FAIL = 'redux-app/team-members/UPDATE_TEAM_MEMBER_FAIL',
  CREATE_TEAM_MEMBER_REQUESTED = 'redux-app/team-members/CREATE_TEAM_MEMBER_REQUESTED',
  CREATE_TEAM_MEMBER_PENDING = 'redux-app/team-members/CREATE_TEAM_MEMBER_PENDING',
  CREATE_TEAM_MEMBER_SUCCESS = 'redux-app/team-members/CREATE_TEAM_MEMBER_SUCCESS',
  CREATE_TEAM_MEMBER_FAIL = 'redux-app/team-members/CREATE_TEAM_MEMBER_FAIL',
  DELETE_TEAM_MEMBER_REQUESTED = 'redux-app/team-members/DELETE_TEAM_MEMBER_REQUESTED',
  DELETE_TEAM_MEMBER_PENDING = 'redux-app/team-members/DELETE_TEAM_MEMBER_PENDING',
  DELETE_TEAM_MEMBER_SUCCESS = 'redux-app/team-members/DELETE_TEAM_MEMBER_SUCCESS',
  DELETE_TEAM_MEMBER_FAIL = 'redux-app/team-members/DELETE_TEAM_MEMBER_FAIL',
  SELECT_TEAM_MEMBER_REQUESTED = 'redux-app/team-members/SELECT_TEAM_MEMBER_REQUESTED',
  CLEAR_TEAM_MEMBERS = 'redux-app/team-members/CLEAR_TEAM_MEMBERS',
}

export default null;
